module.exports = __webpack_public_path__ + "img/hic-cerebrovascular-disease-female.ba17ee8f.png";